module.exports = __webpack_public_path__ + "static/media/1026531.944262c8.jpg";